<div class="p-home">
  <app-header></app-header>
  <section class="headline">
    <div class="headline-wrap">
      <h1 translate="main_title"></h1>

      <div class="search-holder">
        <input type="text" class="search-input" placeholder="{{'main_search_placeholder' | translate}}"
          [(ngModel)]="textFilter" />
        </div>
      </div>

      <app-copyright></app-copyright>
    </section>

    @if (jobs(); as jobs) {
      <div class="wrap">
        <div class="o-filter">
          <div class="align-left">
            <app-department-filter [departments]="departments()"
              [jobs]="(jobs | search:'name':textFilter | search: 'location.city':locationFilter)"
            (departmentFilterChanged)="departmentFilterChanged($event)"></app-department-filter>
            <app-location-filter [locations]="locations()"
              [jobs]="(jobs | search:'name':textFilter | search: 'function.label':departmentFilter)"
              (locationFilterChanged)="locationFilterChanged($event)">
            </app-location-filter>
          </div>
          <div class="align-right">
            <app-job-order (orderChanged)="orderChanged($event)"></app-job-order>
          </div>
        </div>
        @if ((jobs | search:'name':textFilter | search: 'function.label':departmentFilter | search: 'location.city':locationFilter | numberOfKeys) > 0) {
          <section class="positions">
            @for (job of jobs | search:'name':textFilter | search: 'function.label':departmentFilter| search: 'location.city':locationFilter | orderBy:orderByField ; track job) {
              <div class="position"
                >
                <app-job [job]="job"></app-job>
              </div>
            }
          </section>
        } @else {
          <div class="empty-state">
            <div class="empty-state--holder">
              <img src="assets/i/empty-state.png" alt="">
              <h3 translate="main_positionNotFound"></h3>
              <p translate="main_positionNotFound_description"></p>
            </div>
          </div>
        }
      </div>
    }
  </div>
  <app-social-sidebar></app-social-sidebar>
